import { BuildingOfficeIcon } from '@heroicons/react/24/solid';
import parse from 'html-react-parser';

type WorkgroupInstructionCardProps = {
  workgroupName?: string;
  medicalInstructions?: string | null;
  messagesForPatient?: string[];
};

export const WorkgroupInstructionCard = ({ workgroupName, medicalInstructions, messagesForPatient }: WorkgroupInstructionCardProps) => {
  if (!workgroupName || (!medicalInstructions && !messagesForPatient?.length)) return null;
  return (
    <div className="flex flex-col rounded-lg bg-orange-50 p-4">
      <div className="text-md flex items-center gap-2 font-medium text-orange-700 md:text-xl">
        <BuildingOfficeIcon className="size-5 flex-shrink-0 text-orange-800" />
        <div>{workgroupName} raccomanda</div>
        <div className="flex h-6 items-center gap-4 rounded-full bg-orange-600 px-3 text-sm text-neutral-inverse">Importante</div>
      </div>
      {medicalInstructions && (
        <div
          data-cy="workgroup-medical-instructions"
          className="mt-4 text-xs font-normal text-neutral-darker md:text-sm [&_ol]:list-inside [&_ol]:list-decimal [&_ul]:list-inside [&_ul]:list-disc"
        >
          {parse(medicalInstructions)}
        </div>
      )}
      {messagesForPatient && messagesForPatient.length > 0 && (
        <div
          data-cy="workgroup-booking-notes"
          className="mt-4 space-y-2 text-xs font-normal text-neutral-darker md:text-sm [&_ol]:list-inside [&_ol]:list-decimal [&_ul]:list-inside [&_ul]:list-disc"
        >
          {messagesForPatient.map((message, index) => (
            <div key={index}>{parse(message)}</div>
          ))}
        </div>
      )}
    </div>
  );
};

type EltyInstructionCardProps = {
  eltyInstructions: string | null | undefined;
};

export const EltyInstructionCard = ({ eltyInstructions }: EltyInstructionCardProps) => {
  if (!eltyInstructions) return null;

  return (
    <div className="flex flex-col rounded-lg bg-brandGreen-50 p-4">
      <div className="text-md flex items-center gap-2 font-medium text-brandGreen-800 md:text-xl">
        <svg xmlns="http://www.w3.org/2000/svg" width="31" height="18" viewBox="0 0 31 18" fill="none">
          <path
            d="M9.29883 9.54776C7.15977 7.36361 7.15977 3.8221 9.29883 1.63795C9.30749 1.62911 9.31615 1.62174 9.32481 1.6129C7.18431 -0.546197 3.73469 -0.537354 1.60429 1.63795C-0.534764 3.8221 -0.534764 7.36361 1.60429 9.54776L7.78619 15.86C8.85572 16.9521 10.2572 17.4974 11.6587 17.4974C13.0602 17.4974 14.4401 16.9594 15.5067 15.8836C15.498 15.8747 15.4894 15.8674 15.4807 15.8585L9.29883 9.54629V9.54776Z"
            fill="#0BBCA7"
          />
          <path
            d="M29.4018 1.64867C27.2627 -0.535477 23.7943 -0.535477 21.6553 1.64867L19.3531 3.99936L17.0438 1.64131C14.9134 -0.534003 11.4637 -0.541372 9.32324 1.61625C9.3319 1.62509 9.34056 1.63246 9.34922 1.64131L15.5311 7.95353C17.6702 10.1377 17.6702 13.6792 15.5311 15.8633C15.5225 15.8722 15.5138 15.8796 15.5051 15.8884C16.5718 16.9628 17.9617 17.5022 19.3531 17.5022C20.7445 17.5022 22.1561 16.9569 23.2257 15.8648L29.4003 9.55996C31.5394 7.37581 31.5394 3.8343 29.4003 1.65015L29.4018 1.64867Z"
            fill="#0F3250"
          />
          <path
            d="M15.532 7.95056L9.34863 1.63834C9.33997 1.62949 9.33131 1.62212 9.32265 1.61328C9.31399 1.62212 9.30533 1.62949 9.29667 1.63834C7.15762 3.82249 7.15762 7.36399 9.29667 9.54814L15.4786 15.8604C15.4872 15.8692 15.4959 15.8766 15.5046 15.8854C15.5132 15.8766 15.5219 15.8692 15.5305 15.8604C17.6696 13.6762 17.6696 10.1347 15.5305 7.95056H15.532Z"
            fill="#5081A0"
          />
        </svg>
        <div>Elty consiglia</div>
      </div>
      <div className="mt-4 text-xs font-normal text-neutral-darker md:text-sm [&_ol]:list-inside [&_ol]:list-decimal [&_ul]:list-inside [&_ul]:list-disc">
        {parse(eltyInstructions)}
      </div>
    </div>
  );
};
